"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _domUtils = require("../../../../utils/domUtils");
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Option = _antd.Select.Option,
  OptGroup = _antd.Select.OptGroup;
var DirectoryTree = _antd.Tree.DirectoryTree;
var isModel = function isModel(node) {
  return !node ? false : node && node.modelId ? true : false;
};
var traversalTree = function traversalTree(data, parentKey) {
  return data.map(function (item) {
    if (item.children) {
      return _objectSpread(_objectSpread({}, item), {}, {
        children: traversalTree(item.children, item.key),
        parentKey: parentKey,
        isLeaf: isModel(item) ? true : item.isLeaf
      });
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      parentKey: parentKey,
      isLeaf: isModel(item) ? true : item.isLeaf
    });
  });
};
var FieldSelect = exports["default"] = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FieldSelect, _PureComponent);
  var _super = _createSuper(FieldSelect);
  function FieldSelect() {
    var _this$props$selectedK, _this$props$selectedK2;
    var _this;
    (0, _classCallCheck2["default"])(this, FieldSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      listProjectOption: [],
      lastFetchId: 0,
      fetching: false,
      dropdown: false,
      searchValue: ((_this$props$selectedK = _this.props.selectedKey) === null || _this$props$selectedK === void 0 ? void 0 : _this$props$selectedK.toString()) || null,
      type: ((_this$props$selectedK2 = _this.props.selectedKey) === null || _this$props$selectedK2 === void 0 ? void 0 : _this$props$selectedK2.toString()) || 'attribute',
      modelVisible: false,
      checkedNodes: Array.isArray(_this.props.arrayModel) ? _this.props.arrayModel : [],
      checkedNodesOld: Array.isArray(_this.props.arrayModel) ? _this.props.arrayModel : []
    };
    _this.onChange = function (value) {
      if (_this.props.isValue === 'attribute' || _this.props.isValue === 'operator') {
        _this.props.setField(value);
      } else {
        _this.props.setField({
          value: value,
          type: _this.props.isValue,
          arrayModel: _this.state.checkedNodes
        });
      }
    };
    _this.onChangeInput = function (e) {
      var value = e.target.value;
      if (_this.props.isValue === 'attribute' || _this.props.isValue === 'operator') {
        _this.props.setField(value);
      } else {
        _this.props.setField({
          value: value,
          type: _this.props.isValue,
          arrayModel: _this.state.checkedNodes
        });
      }
    };
    _this.filterOption = function (input, option) {
      var dataForFilter = option;
      var keysForFilter = ["title", "value", "grouplabel", "label"];
      var valueForFilter = keysForFilter.map(function (k) {
        return typeof dataForFilter[k] === "string" ? dataForFilter[k] : "";
      }).join("\0");
      return valueForFilter.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    _this.handleSearchObjectInfo = (0, _debounce["default"])( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(value) {
        var fetchId, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                listProjectOption: [],
                fetching: true,
                searchValue: value || null
              });
              _this.props.setField(value);
              if (!(value && value !== "")) {
                _context.next = 17;
                break;
              }
              _this.setState(function (prevState) {
                return {
                  lastFetchId: prevState.lastFetchId + 1
                };
              });
              fetchId = _this.state.lastFetchId;
              _context.prev = 5;
              _context.next = 8;
              return _this.props.searchObject(value);
            case 8:
              res = _context.sent;
              if (!(fetchId !== _this.state.lastFetchId)) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              _this.setState({
                listProjectOption: res,
                fetching: false
              });
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](5);
              _this.setState({
                fetching: false
              });
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 14]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 500);
    _this.splitAtFirstSpecialCharacter = function (str, character) {
      if (!str) return [];
      var i = str.indexOf(character);
      if (i > 0) {
        return [str.substring(0, i), str.substring(i + 1)];
      } else return [str];
    };
    _this.splitTextObjectInfo = function (text) {
      var value = _this.splitAtFirstSpecialCharacter(text, '=');
      return value ? value[0] : '';
    };
    _this.handleClick = function () {
      _this.setState(function (prevState) {
        return {
          dropdown: !prevState.dropdown
        };
      });
    };
    _this.onCheck = function (checkedKeys) {
      _this.setState({
        checkedNodes: checkedKeys
      });
    };
    _this.onClickHideShowModal = function (data) {
      _this.setState({
        modelVisible: data
      });
    };
    _this.onOk = function () {
      _this.setState({
        checkedNodesOld: _this.state.checkedNodes
      });
      _this.props.setField({
        value: _this.props.selectedKey,
        type: _this.props.isValue,
        arrayModel: _this.state.checkedNodes
      });
      _this.onClickHideShowModal(false);
    };
    return _this;
  }
  (0, _createClass2["default"])(FieldSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        config = _this$props.config,
        customProps = _this$props.customProps,
        items = _this$props.items,
        placeholder = _this$props.placeholder,
        selectedKey = _this$props.selectedKey,
        selectedLabel = _this$props.selectedLabel,
        selectedAltLabel = _this$props.selectedAltLabel,
        selectedFullLabel = _this$props.selectedFullLabel,
        readonly = _this$props.readonly,
        isValue = _this$props.isValue,
        treeProject = _this$props.treeProject,
        typeData = _this$props.typeData;
      var dropdownPlacement = config.settings.dropdownPlacement;
      var dropdownAlign = dropdownPlacement ? _domUtils.BUILT_IN_PLACEMENTS[dropdownPlacement] : undefined;
      var tooltipText = selectedAltLabel || selectedFullLabel;
      if (tooltipText === selectedLabel) tooltipText = null;
      var treeData = traversalTree(treeProject || []);
      var fieldSelectItems = this.renderSelectItems(items);
      var res;
      switch (true) {
        case isValue === 'type':
          res = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_antd.Select, (0, _extends2["default"])({
            dropdownAlign: dropdownAlign,
            dropdownMatchSelectWidth: false,
            style: {
              width: 100,
              marginLeft: 10
            },
            placeholder: 'Type',
            onChange: this.onChange,
            value: typeof selectedKey === 'string' ? selectedKey : undefined,
            filterOption: this.filterOption,
            disabled: readonly
          }, customProps), /*#__PURE__*/_react["default"].createElement(Option, {
            label: 'Attribute',
            key: 'attribute',
            value: 'attribute'
          }, "Attribute"), /*#__PURE__*/_react["default"].createElement(Option, {
            label: 'Folder',
            key: 'folder',
            value: 'folder'
          }, "Folder")), typeData === 'folder' && /*#__PURE__*/_react["default"].createElement(_antd.Button, {
            style: {
              marginLeft: 10
            },
            onClick: function onClick() {
              return _this2.onClickHideShowModal(true);
            }
          }, "Data tree"));
          break;
        case isValue === 'operator':
          res = typeData !== 'folder' && /*#__PURE__*/_react["default"].createElement(_antd.Select, (0, _extends2["default"])({
            dropdownAlign: dropdownAlign,
            dropdownMatchSelectWidth: false,
            style: {
              width: 150,
              marginLeft: 10
            },
            placeholder: placeholder,
            onChange: this.onChange,
            value: typeof selectedKey === 'string' ? selectedKey : undefined,
            filterOption: this.filterOption,
            disabled: readonly
          }, customProps), fieldSelectItems);
          break;
        case isValue === 'value' || !this.props.searchObject:
          res = typeData !== 'folder' && /*#__PURE__*/_react["default"].createElement(_antd.Input, (0, _extends2["default"])({
            style: {
              width: 150,
              marginLeft: 10
            },
            placeholder: 'Value',
            onChange: this.onChangeInput,
            value: typeof selectedKey === 'string' ? selectedKey : undefined,
            disabled: readonly
          }, customProps));
          break;
        case isValue === 'attribute':
          res = typeData !== 'folder' && /*#__PURE__*/_react["default"].createElement(_antd.Select, {
            allowClear: true,
            style: {
              width: 150,
              marginLeft: 10
            },
            disabled: readonly,
            showSearch: true,
            value: typeof selectedKey === 'string' ? selectedKey : undefined,
            optionFilterProp: "children",
            placeholder: 'Attribute',
            notFoundContent: this.state.fetching ? /*#__PURE__*/_react["default"].createElement(_antd.Spin, {
              size: "small"
            }) : null,
            filterOption: false,
            onChange: this.onChange,
            onSearch: this.handleSearchObjectInfo,
            open: this.state.dropdown,
            onFocus: function onFocus() {
              return _this2.setState({
                dropdown: true
              });
            },
            onBlur: function onBlur() {
              return _this2.setState({
                dropdown: false
              });
            },
            onDropdownVisibleChange: this.handleClick,
            onClear: function onClear() {
              _this2.setState({
                searchValue: ''
              });
              _this2.props.setField('');
            }
          }, this.state.searchValue ? /*#__PURE__*/_react["default"].createElement(Option, {
            label: this.state.searchValue,
            key: 'searchValue',
            value: this.state.searchValue
          }, this.state.searchValue) : null, this.state.listProjectOption && this.state.listProjectOption.map(function (d) {
            return /*#__PURE__*/_react["default"].createElement(Option, {
              label: _this2.splitTextObjectInfo(d.inf),
              key: (d === null || d === void 0 ? void 0 : d._id) || (d === null || d === void 0 ? void 0 : d.id),
              value: _this2.splitTextObjectInfo(d.inf)
            }, _this2.splitTextObjectInfo(d.inf));
          }));
          break;
        default:
          res = /*#__PURE__*/_react["default"].createElement("div", null);
          break;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, res, /*#__PURE__*/_react["default"].createElement(_antd.Modal, {
        title: "Select 4D Node in Data Tree",
        centered: true,
        zIndex: 10001,
        visible: this.state.modelVisible,
        open: this.state.modelVisible,
        onCancel: function onCancel() {
          _this2.onClickHideShowModal(false);
          _this2.setState({
            checkedNodes: _this2.state.checkedNodesOld
          });
        },
        onOk: function onOk() {
          return _this2.onOk();
        },
        style: {
          maxHeight: 'calc(100vh - 20px)'
        },
        bodyStyle: {
          maxHeight: 'calc(100vh - 300px)',
          overflowY: 'auto'
        }
      }, treeData !== null && treeData !== void 0 && treeData.length ? /*#__PURE__*/_react["default"].createElement(DirectoryTree, {
        multiple: true,
        defaultExpandAll: true,
        checkable: true,
        checkedKeys: this.state.checkedNodes,
        treeData: treeData,
        onCheck: this.onCheck
      }) : /*#__PURE__*/_react["default"].createElement(_antd.Empty, null)));
    }
  }, {
    key: "renderSelectItems",
    value: function renderSelectItems(fields) {
      var _this3 = this;
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return fields === null || fields === void 0 ? void 0 : fields.map(function (field) {
        var items = field.items,
          key = field.key,
          path = field.path,
          label = field.label,
          fullLabel = field.fullLabel,
          altLabel = field.altLabel,
          tooltip = field.tooltip,
          grouplabel = field.grouplabel,
          disabled = field.disabled;
        var groupPrefix = level > 0 ? "\xA0\xA0".repeat(level) : "";
        var prefix = level > 1 ? "\xA0\xA0".repeat(level - 1) : "";
        var pathKey = path || key;
        if (items) {
          var simpleItems = items.filter(function (it) {
            return !it.items;
          });
          var complexItems = items.filter(function (it) {
            return !!it.items;
          });
          var gr = simpleItems.length ? [/*#__PURE__*/_react["default"].createElement(OptGroup, {
            key: pathKey,
            label: groupPrefix + label
          }, _this3.renderSelectItems(simpleItems, level + 1))] : [];
          var list = complexItems.length ? _this3.renderSelectItems(complexItems, level + 1) : [];
          return [].concat(gr, (0, _toConsumableArray2["default"])(list));
        } else {
          var option = tooltip ? /*#__PURE__*/_react["default"].createElement(_antd.Tooltip, {
            title: tooltip
          }, prefix + label) : prefix + label;
          return /*#__PURE__*/_react["default"].createElement(Option, {
            key: pathKey,
            value: pathKey,
            title: altLabel,
            grouplabel: grouplabel,
            label: label,
            disabled: disabled
          }, option);
        }
      }).flat(Infinity);
    }
  }]);
  return FieldSelect;
}(_react.PureComponent);
FieldSelect.propTypes = {
  config: _propTypes["default"].object.isRequired,
  customProps: _propTypes["default"].object,
  items: _propTypes["default"].array.isRequired,
  placeholder: _propTypes["default"].string,
  selectedKey: _propTypes["default"].string,
  selectedKeys: _propTypes["default"].array,
  selectedPath: _propTypes["default"].array,
  selectedLabel: _propTypes["default"].string,
  selectedAltLabel: _propTypes["default"].string,
  selectedFullLabel: _propTypes["default"].string,
  selectedOpts: _propTypes["default"].object,
  readonly: _propTypes["default"].bool,
  setField: _propTypes["default"].func.isRequired,
  searchObject: _propTypes["default"].func,
  isValue: _propTypes["default"].bool,
  arrayModel: _propTypes["default"].array,
  treeProject: _propTypes["default"].object,
  typeData: _propTypes["default"].string
};